import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'gatsby-plugin-intl';

import Container from '../../layout/Container';
import { translateLocal } from '../../../i18n';

import './PassCTABlock.scss';

const PassCTABlock = ({
  data, link,
}) => {

  return (
    <div className="pass-cta-block">
      <Container>
        <div className="title">{translateLocal(data.title)}</div>

        <Link to={link} className="button sm primary">{translateLocal(data.buttonLabel)}</Link>

        <img src={data.imageLeft.src} alt="" className="image left" />
        <img src={data.imageRight.src} alt="" className="image right" />
      </Container>
    </div>
  );
};

PassCTABlock.propTypes = {
  data: PropTypes.object.isRequired,
  link: PropTypes.string,
};

PassCTABlock.defaultProps = {
  link: '/',
};

export default PassCTABlock;
